import React, { useEffect, useState } from 'react';
import { getStudentVideosCourses } from '../../../service/student/student.service';
import Loaders from '../../../components/loaders/Loaders';
import BreadcrumbBack from '../../../components/breadcrumb/BreadcrumbBack';
import { FaVideo } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import BreadCrumb from '../../../components/breadcrumb/BreadCrumb';
import Cookies from 'js-cookie';
import { BreadCrumRoutes } from '../../../helpers/helpers';
import DataNotFound from '../../../components/errors/DataNotFound';
import { Helmet } from 'react-helmet-async';

export default function StudentVideo() {
  const [pageLoad, setPageLoad] = useState(false);
  const [fetchData, setFetchData] = useState<any>([]);
  const [bradCrumData, setBreadcrumbData] = useState<any>();
  const navigate = useNavigate();
  const fetchVideos = async () => {
    setPageLoad(true);
    let get: any = await getStudentVideosCourses();
    if (get?.status === 'success') {
      setPageLoad(false);
      setFetchData(get?.message);
    }
    setPageLoad(false);
  };

  useEffect(() => {
    fetchVideos();
    setBreadcrumbData(
      BreadCrumRoutes('Video', '/student/videos', 'studentVideo', true)
    );
  }, []);

  return pageLoad ? (
    <Loaders type="spinner" />
  ) : (
    <>
      <Helmet>
        <title>{`Videos | ${window.location.hostname}`}</title>
      </Helmet>
      <BreadCrumb routes={bradCrumData} />
      <div className="my-2 grid grid-cols-12 gap-3">
        {fetchData?.length > 0 ? (
          fetchData.map((item: any, index: number) => (
            <div
              onClick={() => navigate(`/student/videos/modules/${item?.id}`)}
              key={index}
              className="lg:col-span-3 hover:cursor-pointer col-span-12 sm:col-span-12 md:col-span-4  bg-gray-200 rounded-xl"
            >
              <div className="flex flex-col  gap-2 ">
                <img
                  src={item?.image}
                  className="h-[200px] w-auto rounded-lg"
                  alt=""
                />
                <p className="text-2xl text-center font-semibold">
                  {item?.name}
                </p>
                <ul className="text-left">
                  <li className="flex justify-between  p-2">
                    <p> Total Videos</p>
                    <p>
                      {' '}
                      {item?.watch}/{item?.totalVideo}
                    </p>
                  </li>
                  {/* <li className='flex justify-between p-2'> 
                                    <p>Total Duration</p>
                                    <p>{item?.totalLength}</p>
                                </li> */}
                </ul>
                <button
                  onClick={() =>
                    navigate(`/student/videos/modules/${item?.id}`)
                  }
                  className="bg-gradient p-2 text-white rounded-lg"
                >
                  Watch Videos
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-12">
            <DataNotFound title="No Videos Found" />
          </div>
        )}
      </div>
    </>
  );
}
